import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "./pages/dashboard/dashboard";
import Faq from "./pages/faq/faq";
import Login from "./pages/login";
import Products from "./pages/products/products";
import ProductDetails from "./pages/products/product-details";
import Brands from "./pages/brands/brands";
import Branches from "./pages/branches";
import Users from "./pages/users/users";
import Models from "./pages/models/models";
import Review from "./pages/review/review";
import VideoReview from "./pages/video-review/video-review";
import Settings from "./pages/settings/settings";
import Layout from "./components/layout/layout";
import RouteGuard from "./components/auth/route-guard";

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <RouteGuard>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route element={<Layout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/branches" element={<Branches />} />
            <Route path="/users" element={<Users />} />
            <Route path="/brands" element={<Brands />} />
            <Route path="/models" element={<Models />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:productId" element={<ProductDetails />} />
            <Route path="/review" element={<Review />} />
            <Route path="/video-reviews" element={<VideoReview />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/" element={<Navigate to="/dashboard" />} />
          </Route>
        </Routes>
      </RouteGuard>
    </BrowserRouter>
  );
};

export default AppRouter;
